import { UPDATE_STATUS_MEETING } from "./actionTypes";
/**
 * Cập nhật trạng thái cuộc họp cho feedback
 * @param status: trạng thái cuộc họp
 */
export function updateStatusMeeting(status) {
    return {
        type: UPDATE_STATUS_MEETING,
        status
    };
}
